"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImportConfigurationHandler = useImportConfigurationHandler;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const StorageClient_1 = require("@juvare/platform-sdk-js/StorageClient");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const ImportConfigurationDialog_1 = require("../components/ImportConfigurationDialog");
const importConfiguration_1 = require("../utils/importConfiguration");
const selectExportFile_1 = require("../utils/selectExportFile");
function useImportConfigurationHandler(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const [open, setOpen] = react_1.default.useState(false);
    const [file, setFile] = react_1.default.useState();
    const [dryRun, setDryRun] = react_1.default.useState(false);
    const [selectedFeatures, setSelectedFeatures] = react_1.default.useState({});
    const [selectedClassifiers, setSelectedClassifiers] = react_1.default.useState({});
    const handleImportButtonClick = react_1.default.useCallback(() => (params.onSelectExportFile ?? selectExportFile_1.selectExportFile)()
        .then((file) => {
        if (file) {
            setOpen(true);
            setFile(file);
            setSelectedFeatures(Object.fromEntries(Object.keys(file).map((feature) => [feature, true])));
            setSelectedClassifiers(Object.fromEntries((params.classifiers ?? [])
                .filter(({ entityName }) => file.classifiers?.[entityName] != null)
                .map(({ entityName }) => [entityName, true])));
        }
    })
        .catch(DialogHelper_1.handleErrorDialog), [params.classifiers, params.onSelectExportFile]);
    const handleDialogClose = react_1.default.useCallback(() => setOpen(false), []);
    const handleDialogClosed = react_1.default.useCallback(() => {
        setFile(undefined);
        setDryRun(false);
        setSelectedFeatures({});
        setSelectedClassifiers({});
        setImportProgress(undefined);
    }, []);
    const [importProgress, setImportProgress] = react_1.default.useState();
    const cancelFunctionRef = react_1.default.useRef(undefined);
    const handleDialogImport = react_1.default.useCallback(() => {
        if (file) {
            cancelFunctionRef.current = (0, importConfiguration_1.importConfiguration)({
                t,
                features: params.features.filter((feature) => selectedFeatures[feature]),
                classifiers: (params.classifiers ?? []).filter((classifier) => selectedClassifiers[classifier.entityName]),
                file,
                dryRun,
                progressCallback: setImportProgress,
                getStorageClient: (entityName) => new StorageClient_1.StorageClient(entityName),
            }).cancel;
        }
    }, [t, file, dryRun, params.classifiers, params.features, selectedClassifiers, selectedFeatures]);
    const handleDialogCancel = react_1.default.useCallback(() => {
        cancelFunctionRef.current?.();
    }, []);
    const importDialog = (react_1.default.createElement(ImportConfigurationDialog_1.ImportConfigurationDialog, { features: params.features, classifiers: params.classifiers, open: open, onClose: handleDialogClose, onClosed: handleDialogClosed, onImport: handleDialogImport, onCancel: handleDialogCancel, file: file, dryRun: dryRun, setDryRun: setDryRun, selectedFeatures: selectedFeatures, setSelectedFeatures: setSelectedFeatures, selectedClassifiers: selectedClassifiers, setSelectedClassifiers: setSelectedClassifiers, importProgress: importProgress }));
    return { handleImportButtonClick, importDialog };
}
